/*
DO NOT MANUALLY TRANSLATE!
Follow the instructions in the README.md to conveniently update translations.
*/

export default {
  "CookieMessage.old.link": "Více informací",
  "CookieMessage.old.text":
    "Pro správnou funkci našeho internetového obchodu používáme soubory cookie. Zobrazit naše zásady používání souboru cookie.",
  "CookieMessage.link": "Cookies prijetí",
  "CookieMessage.more_information":
    "Další informace o souborech cookie spolecnosti Kramp",
  "CookieMessage.return": "Zpet",
  "CookieMessage.intro.body":
    'Tyto soubory cookie byly na web umísteny spolecností Kramp i tretími stranami. Netreba dodávat, že se o Vaše soukromí dobre staráme. Pokud kliknete na možnost "Prijmout soubory cookie" níže, vyjadrujete souhlas s používáním techto souboru cookie. Prijetím používání souboru cookie zajistíte, že náš web bude fungovat správne. Príklady toho, k cemu se tyto soubory používají:',
  "CookieMessage.intro.list.1": "Automatické prihlášení k Vašemu úctu",
  "CookieMessage.intro.list.2": "Analýza chování návštevníku k vylepšení webu",
  "CookieMessage.intro.list.3":
    "Tvorba profilu zákazníku umožnující nám poskytovat prizpusobené nabídky a inzerci",
  "CookieMessage.intro.extra":
    'Pokud nechcete prijímat všechny soubory cookie, mužete provést zmenu v <a>nastavení</a>. Další informace naleznete v našem <a href="{legalLink}">prohlášení o zásadách ochrany soukromí a používání souboru cookie</a>.',
  "CookieMessage.intro.title": "Spolecnost Kramp používá soubory cookie",
  "CookieMessage.settings.body":
    'Mužete vybrat ze trí nastavení souboru cookie. Výberem nastavení "Standardní" nám umožníte poskytnout Vám nejlepší zkušenost s webem.',
  "CookieMessage.settings.standard.title": "Standardní (nejoblíbenejší):",
  "CookieMessage.settings.standard.body":
    "Soubory cookie používané pro prihlášení, objednávání, prizpusobené nabídky, sociální média a soubory cookie od jiných stran v rámci Evropy i mimo ni.",
  "CookieMessage.settings.restricted.title": "Omezené:",
  "CookieMessage.settings.restricted.body":
    "Soubory cookie používané pro prihlášení, objednávání, analýzu a prizpusobené nabídky.",
  "CookieMessage.settings.highly_restricted.title": "Vysoce omezené:",
  "CookieMessage.settings.highly_restricted.body":
    "Povolujete pouze minimální množství souboru cookie. Používá se výhradne pro prihlášení, objednávání a umožnení správného fungování webu.",
  "CookieMessage.settings.options.title": "Naše využití:",
  "CookieMessage.settings.option.1":
    "Používání souboru cookie k zajištení správných funkcí webu",
  "CookieMessage.settings.option.2": "Zkoumání chování uživatelu",
  "CookieMessage.settings.option.3": "Sledování osobních statistik",
  "CookieMessage.settings.option.4":
    "Zobrazení informací, které by Vás mohly zajímat",
  "CookieMessage.settings.option.5": "Používání informací pro naši inzerci",
  "CookieMessage.settings.option.6": "Anonymní sledování pro úcely statistik",
  "CookieMessage.settings.option.7": "Sdílení Vašich osobních údaju",
  "CookieMessage.settings.title": "Nastavení souboru cookie",
  "CookiePage.url": "ochrana-osobnich-udaju-cookies",
};
